module.exports = __webpack_public_path__ + "img/PersonalData.c575d5bc.svg";